import React from "react";
import { Form, FormikProps } from "formik";
import { Grid } from "@material-ui/core";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { SubmitButton } from "components/buttons";
import { CheckboxWithErrorLabel as Checkbox } from "components/haven-design/form/checkbox";
export interface QueryParams {
  email: string;
  firstName: string;
  lastName: string;
  strict: boolean;
}

type FormProps = FormikProps<QueryParams>

const InterestSearchForm: React.FC<FormProps> = () => (
  <Form>
    <Grid container spacing={2} >
      <Grid item md={6}>
        <Input type="text" name="firstName" label="First Name" placeholder="First name" />
      </Grid>
      <Grid item md={6}>
        <Input type="text" name="lastName" label="Last Name" placeholder="Last name" />
      </Grid>
      <Grid item md={12}>
        <Input type="text" name="email" label="Email Address" />
      </Grid>
      <Grid item md={6}>
        <Checkbox name="strict" label="Exact results only" />
        <SubmitButton text="Search" />
      </Grid>
    </Grid>
  </Form>
);

export default InterestSearchForm;
